import React from "react";
import { useProducts } from "../../../state/api/products/useProducts";
import Pill from "../pill/Pill";

export default function AccessLevelPill() {
  const { products } = useProducts();

  if (!products?.length) {
    return null;
  }

  const shortcodes = [];

  console.log(products);

  for (const p of products) {
    if (p.hasAccess && !!p.requiredTags.length) {
      shortcodes.push(p.shortcode);
    }
  }

  if (!shortcodes.length) {
    shortcodes.push("FREE");
  }

  return (
    <Pill
      background="var(--teal-100)"
      foreground="var(--teal-600)"
      border="1px solid var(--gray-200)"
      round
    >
      <div className="d-flex flex-row gap-1 align-items-center fw-normal">
        <div style={{ height: 6, width: 6, borderRadius: "50%", backgroundColor: "var(--primaryAccent)" }} />
        <span className="font-light text-uppercase fw-light">Access:</span>
        <span style={{ fontWeight: "600" }}>
          {shortcodes.join(", ")}
        </span>
      </div>
    </Pill>
  )
}